var map = {
	"./IIT-removebg-preview.png": 162,
	"./IMG_0560-modified.png": 163,
	"./IMG_0560.jpeg": 164,
	"./KevinVora1.png": 165,
	"./Nirma_University_Logo-removebg-preview.png": 166,
	"./address_image.svg": 167,
	"./animated_logo.svg": 168,
	"./arizona-removebg-preview.png": 169,
	"./arizona.png": 170,
	"./arizzona.png": 171,
	"./blogs_image.svg": 172,
	"./cloud_infrastructure.svg": 173,
	"./codeInLogo.png": 174,
	"./contactMail.png": 175,
	"./coursera_logo.png": 176,
	"./data_science.svg": 177,
	"./deeplearning_ai_logo.png": 178,
	"./delhivery_logo.png": 179,
	"./developerActivity.svg": 180,
	"./dsc_logo.png": 181,
	"./education.svg": 182,
	"./experience.svg": 183,
	"./feelingProud.svg": 184,
	"./freecopy_logo.png": 185,
	"./fullstack.svg": 186,
	"./gcp_logo.png": 187,
	"./github_logo.png": 188,
	"./googleAssistant.jpg": 189,
	"./googleAssistant.svg": 190,
	"./google_logo.png": 191,
	"./ibm_logo.png": 192,
	"./iiitk_logo.png": 193,
	"./img.png": 194,
	"./imp.png": 195,
	"./intel_logo.jpg": 196,
	"./jsFramework.svg": 197,
	"./kevin.png": 198,
	"./legato_logo.png": 199,
	"./manOnTable.svg": 200,
	"./microsoft_logo.png": 201,
	"./mozilla_logo.png": 202,
	"./muffito_logo.png": 203,
	"./nextuLogo.jpg": 204,
	"./nptel_logo.png": 205,
	"./portfolio.gif": 206,
	"./profile-pic.png": 207,
	"./programmer.svg": 208,
	"./projects_image.svg": 209,
	"./pwa.png": 210,
	"./saayaHealthLogo.png": 211,
	"./skyfilabs-logo-v1-removebg-preview.png": 212,
	"./stanford_logo.png": 213,
	"./talksCardBack.svg": 214,
	"./talksCardBackAlt.svg": 215,
	"./udemy-removebg-preview.png": 216,
	"./ui_ux_design.svg": 217,
	"./undraw_robotics_kep0.svg": 218,
	"./unity.svg": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;